import React from 'react';
import PropTypes from 'prop-types';
import { Button, Typography } from '@one-thd/sui-atomic-components';
import ErrorBoundary from '../contexts/ErrorBoundary';
import { BannerContext, BannerProvider } from '../contexts/BannerContext';
import MarketingPreferencesCard from './common/MarketingPreferencesCard';
import { initialProXtraTableData } from './tableData';

export const proXtraTestId = 'proXtra-preferences-component';

export function Preferences({ email }) {
  const {
    openErrorAlert, openSuccessAlert, openEmailUnsubSuccessAlert, closeSuccessAlert,
    closeEmailUnsubSuccessAlert, selectedUndo
  } = React.useContext(BannerContext);

  const [tableData, setTableData] = React.useState(initialProXtraTableData());
  const [selected, setSelected] = React.useState([]);
  const [isProXtra, setIsProXtra] = React.useState(true);

  return (
    <div className="sui-grid sui-gap-4" data-testid={proXtraTestId}>
      <Typography variant="h2" weight="display">PRO XTRA LOYALTY EMAILS</Typography>
      <Typography variant="body-base" height="none">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
        ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
        laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
        voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
        cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.

      </Typography>
      <MarketingPreferencesCard
        tableData={tableData}
        setTableData={setTableData}
        setSelected={setSelected}
        isProXtra={isProXtra}
      />
      <div className="sui-grid sui-grid-cols-8">
        <div className="hidden sm:sui-col-span-4 md:sui-col-span-5" />
        <div className="sui-col-span-8 sm:sui-col-span-4 md:sui-col-span-3 sui-grid sui-gap-y-4">
          <Button fullWidth>
            Save Changes
          </Button>
          <Button
            fullWidth
            variant="secondary"
          >
            Opt Out From All Pro Xtra Loyalty Emails
          </Button>
        </div>
      </div>
    </div>
  );
}

function ProXtraPreferences({ email }) {

  return (
    <ErrorBoundary>
      <BannerProvider>
        <Preferences email={email} />
      </BannerProvider>
    </ErrorBoundary>
  );
}

export default ProXtraPreferences;

const proptypes = {
  email: PropTypes.string.isRequired
};

ProXtraPreferences.propTypes = proptypes;
Preferences.propTypes = proptypes;
